module.exports = __webpack_public_path__ + "static/media/undraw_festivities_tvvj.83dccd58.png";